var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    d: "M2.294-2.442A2.844,2.844,0,0,0,5.217.407,2.782,2.782,0,0,0,8.066-2.442,2.791,2.791,0,0,0,5.217-5.328,2.875,2.875,0,0,0,2.294-2.442ZM11.655-9.1A9.507,9.507,0,0,0,21.275.407a8.789,8.789,0,0,0,7.659-4.218L26.2-5.92a5.924,5.924,0,0,1-4.884,2.738,5.707,5.707,0,0,1-5.7-5.92,5.7,5.7,0,0,1,5.7-5.883A5.782,5.782,0,0,1,26.2-12.21l2.738-2.146a8.658,8.658,0,0,0-7.659-4.218A9.5,9.5,0,0,0,11.655-9.1ZM31.524-3.108A9.124,9.124,0,0,0,38.85.407a7.816,7.816,0,0,0,4.81-1.443,4.889,4.889,0,0,0,1.924-4.107c0-2.553-1.517-4.033-4.958-5.476l-1.739-.7c-1.776-.74-2.405-1.221-2.405-2.146,0-1.147.962-1.739,2.479-1.739a5.918,5.918,0,0,1,4.255,1.85l2.109-2.4a7.775,7.775,0,0,0-6.29-2.812c-3.7,0-6.4,2-6.4,5.254,0,2.553,1.517,3.959,4.736,5.291l1.85.777C41-6.512,41.773-6.068,41.773-5c0,1.332-1.258,2.035-2.923,2.035-1.924,0-3.515-.925-5.106-2.59ZM62.53-18.167,57.239-6.142,51.911-18.167H47.767L56.573.407H57.9l8.769-18.574Z",
    transform: "translate(925 464)",
    fill: "#0a64f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.7c0a1110339d6cb28010a74851f05f69.svg";
export { ForwardRef as ReactComponent };